import React from 'react'

export default function LeadError({ message, className, color = "text-red-600" }) {

  return (
    <div className={['text-sm mt-1', color, className]}>
      {message}
    </div>
  )
}
